/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
// eslint-disable-next-line no-unused-vars
import {
    Account,
    AccountFromJSON,
    AccountToJSON,
} from './';

/**
 * 
 * @export
 * @interface AccountSearchResponse
 */
export interface AccountSearchResponse {
    /**
     * Cursor to fetch next set of results.
     * @type {string}
     * @memberof AccountSearchResponse
     */
    cursor?: string;
    /**
     * 
     * @type {Array<Account>}
     * @memberof AccountSearchResponse
     */
    results: Array<Account>;
}

export function AccountSearchResponseFromJSON(json: any): AccountSearchResponse {
    return {
        'cursor': !exists(json, 'cursor') ? undefined : json['cursor'],
        
        'results': (json['results'] as Array<any>).map(AccountFromJSON),
        
    };
}

export function AccountSearchResponseToJSON(value?: AccountSearchResponse): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'cursor': value.cursor,
        
        'results': (value.results as Array<any>).map(AccountToJSON),
        
    };
}


